import { ofType } from "redux-observable";
import { catchError, combineLatestWith, map, switchMap, withLatestFrom } from "rxjs/operators";
import { asyncScheduler, EMPTY, forkJoin, from, iif, of, scheduled } from "rxjs";
import * as _ from 'lodash';

import * as validazioneActionType from "../../actions/actionsTypes/validazioneActionType";
import * as typesDatiRegistro from "../../actions/actionsTypes/datiRegistroActionType";

import { notifsActions, datiRegistroActions, timbratureActions, giustificativiActions } from "../../actions";
import { TAB_ENUM_INDIVIDUI_TARGET } from "../../costanti";
import { createMessageRequestException } from "../../fanctionUtility";

import { dayJS } from "../../applicationConf";
import new_axios_instance from "../../axios_instance";
import { initValidati, recuperaValidatiEnd, removeValidationEnd } from "../../slices/validazioneSlice";
import store from '../../store';
import { corsoCorsiActions } from "../../slices/corso_corsiSlice";

export const removeValidations = (actions$) =>
    actions$.pipe(
        ofType(validazioneActionType.REMOVE_VALIDATION),
        switchMap(({ payload: { data, motivazione, tab } }) =>
            forkJoin([...data.reduce((acc, el) => {
                acc.push(...el.idsValidation.map(idValidazione =>
                    from(
                        new_axios_instance.put(`/v1/registro/${TAB_ENUM_INDIVIDUI_TARGET[tab].timbratura}/elimina/${idValidazione}`,
                            ({ motivazione }))
                    ).pipe(
                        map(_ => null),
                        catchError(err => of({ [el.name]: createMessageRequestException(err) }))
                    )
                ));
                return acc;
            }, [])]
            )
        ),
        switchMap(values => {
            sessionStorage.removeItem('validationCache')
            return iif(() => values.every(el => el == null),
                of(
                    notifsActions.notifSuccess(`Operazione avvenuta con successo per n. ${values.filter(el => el == null).length} su n. ${values.length}`),
                    removeValidationEnd()
                ),
                iif(() => values.every(el => el != null),
                    of(
                        notifsActions.notifError([...new Set(values.filter(el => el != null).map(el => Object.values(el)[0]))]),
                        removeValidationEnd()
                    ), of(
                        notifsActions.notifWarning(`Operazione avvenuta con successo per n. ${values.filter(el => el == null).length} su n. ${values.length}`),
                        notifsActions.notifError([...new Set(values.filter(el => el != null).map(el => Object.values(el)[0]))]),
                        removeValidationEnd()
                    )
                )
            )
        })
    );

export const recoveryDatiRegistro = (actions$, state$) =>
    actions$.pipe(
        ofType(typesDatiRegistro.RICERCA_TIMBRATURE_START_REGISTRO_ACTION),

        switchMap(({ reqs, tab, page, cognome }) => {
            sessionStorage.setItem('registroLoading', 'true');
            
            // Se non ci sono individui in incarico/non ritirati per questo periodo, restituisci dati vuoti
            if (!reqs || reqs.length === 0) {
                sessionStorage.setItem('registroLoading', 'false');
                return of({
                    dataRegistryRespCopy: [],
                    individuoRegistryRespCopy: [],
                    totalCount: 0,
                    validation: [],
                    validationError: [],
                    dataRegistryError: []
                });
            }
            
            let adjustedDates = adjustDates(reqs[0].daData, reqs[0].aData);
            reqs[0].daData = adjustedDates[0];
            reqs[0].aData = adjustedDates[1];

            return of({ tab }).pipe(
                combineLatestWith(
                    from(
                        page
                            ? from(new_axios_instance
                                .get(`/v1/timbratura/controllo/corso/${reqs[0].idCorso}/daData/${reqs[0].daData}/aData/${reqs[0].aData}/${tab}/${isNaN(parseInt(page)) ? 1 : page}`, {
                                    params: { cognome },
                                }))
                                .pipe(
                                    catchError((error) => {
                                        sessionStorage.setItem('registroLoading', 'false');
                                        store.dispatch(corsoCorsiActions.getCorsoFail(true));
                                        return EMPTY;
                                    })
                                )
                            : from(new_axios_instance
                                .get(`/v1/timbratura/controllo/corso/${reqs[0].idCorso}/idAnagrafica/${reqs[0].idAnagrafica}/daData/${reqs[0].daData}/aData/${reqs[0].aData}`))
                                .pipe(
                                    catchError((error) => {
                                        sessionStorage.setItem('registroLoading', 'false');
                                        store.dispatch(corsoCorsiActions.getCorsoFail(true));
                                        return EMPTY;
                                    })
                                )
                    ),
                    from(new_axios_instance
                        .get(`/v1/registro/${TAB_ENUM_INDIVIDUI_TARGET[tab].timbratura}/ricerca/corso/${reqs[0].idCorso}/${reqs[0].daData.split('-')[0]}/${reqs[0].daData.split('-')[1]}/${isNaN(parseInt(page)) ? 1 : page}`,  {
                            params: { cognome },
                        }))
                        .pipe(
                            catchError((error) => {
                                sessionStorage.setItem('registroLoading', 'false');
                                console.error('Error in validation request', error);
                                store.dispatch(corsoCorsiActions.getCorsoFail(true));
                                return EMPTY;
                            })
                        )
                ),
                map(([params, dataRegistryResp, dataValidationResp]) => {
                    let dataRegistryRespCopy = [];
                    let individuoRegistryRespCopy = [];
                    let validation = [];
                    let sanitizedTab = params.tab === 'docenti' ? 'docente' : 'allievo';
                    const uniqueIdAnagraficaArray = Array.from(new Set(dataRegistryResp.data.responses.map((registry) => registry.idAnagrafica)));

                    for (const idAnagrafica of uniqueIdAnagraficaArray) {
                        let registryData = dataRegistryResp.data.responses.filter((x) => x.idAnagrafica === idAnagrafica);
                        if (page) {
                            dataRegistryRespCopy.push({ idAnagrafica, registry: registryData });
                        } else {
                            individuoRegistryRespCopy.push({ idAnagrafica, registry: registryData });
                        }
                    }

                    for (const idAnagrafica of uniqueIdAnagraficaArray) {
                        validation.push({
                            idAnagrafica,
                            mesiValidati: dataValidationResp.data
                                .filter((x) => x[sanitizedTab]?.idAnagrafica === idAnagrafica)
                                .map((m) => _.merge(m, { idAnagrafica })),
                            nomeMesi: dataValidationResp.data
                                .filter((x) => x[sanitizedTab]?.idAnagrafica === idAnagrafica)
                                .map((mese) => dayJS(mese.mese, 'YYYY-MM').format('YYYY - MMMM')),
                            isError: false,
                        });
                    }

                    const dataRegistryError = [];
                    const validationError = [];

                    sessionStorage.setItem('registroLoading', 'false');

                    return {
                        dataRegistryRespCopy: dataRegistryRespCopy,
                        individuoRegistryRespCopy: individuoRegistryRespCopy,
                        totalCount: dataRegistryResp.data.totalCount,
                        validation,
                        validationError,
                        dataRegistryError,
                    };
                })
            );
        }),
        withLatestFrom(state$),
        switchMap(([response, state]) => {
            return scheduled(
                [
                    recuperaValidatiEnd({ validation: response.validation, validationError: response.validationError }),
                    datiRegistroActions.ricercaTimbratureStartPerRegistroEnd(
                        response.dataRegistryRespCopy,
                        response.individuoRegistryRespCopy,
                        response.totalCount,
                        response.dataRegistryError
                    ),
                ],
                asyncScheduler
            );
        })
    );



function adjustDates(start, end) {
    start = new Date(new Date(start).getFullYear(), new Date(start).getMonth(), 1)
    end = new Date(new Date(end).getFullYear(), new Date(end).getMonth() + 1, 0)
    return [
        `${start.getFullYear()}-${(start.getMonth() + 1).toString().padStart(2, '0')}-${(start.getDate()).toString().padStart(2, '0')}`,
        `${end.getFullYear()}-${(end.getMonth() + 1).toString().padStart(2, '0')}-${end.getDate().toString().padStart(2, '0')}`
    ]
}

export const initResocontoMese = (actions$) =>
    actions$.pipe(
        ofType(typesDatiRegistro.INIT_RESOCONTO_MESE_ACTION),
        switchMap(() =>
            of(
                datiRegistroActions.initResocontoMeseReducer(),
                timbratureActions.initTimbrature(),
                giustificativiActions.initRequestGiustificativi(),
                initValidati()
            )
        )
    );
